// extracted by mini-css-extract-plugin
module.exports = {"root":"drawer-header_root__1EqsT"};